module.exports = __webpack_public_path__ + "img/logo_top.png";